import api, { type CommonResponse } from './base'

export function fetchVipProducts() {
  return api.get<
    never,
    {
      productList: VipSku[]
    }
  >('/v1/products/vip')
}

export interface VipSku {
  id: number
  name: string
  price: number
  originalPrice?: number
  pricePerMonth: number
  period: number
  periodType: 'DAY' | 'MONTH'
  currency: 'CNY'
  campaignName?: string
  defaultSelected: boolean
  shortName: string
  appleProductId?: string
}

export interface DiamondCardSku {
  id: number
  immediateDiamonds: number
  diamondsPerDay: number
  price: number
  originalPrice?: number
  currency: 'CNY'
  appleProductId?: string
}

export interface DiamondSku {
  id: number
  amount: number
  price: number
  currency: 'CNY'
  appleProductId?: string
}

export type StoreConfig = {
  vipPrivilegeResponse: {
    addEnergyLimit: number
    freeEnergyPerDay: number
  }
  vipList: VipSku[]
  diamondList: DiamondSku[]
  diamondCard: DiamondCardSku
  alphaGift?: {
    diamond: number
  }
}

export async function fetchStoreProducs(): Promise<StoreConfig> {
  return api.get<never, StoreConfig>('/v1/products/store')
}

export type DiamondCardResponse = {
  receivedToday: boolean
  diamondPerDay: number
  immediateDiamonds: number

  // date
  nextRefreshAt: string
}

export async function fetchDiamondCard() {
  return api.get<never, { status: DiamondCardResponse }>(
    '/v1/diamonds/diamond-card'
  )
}

export async function receiveDiamondCardDailyDiamonds() {
  return api.post<never, CommonResponse<void>>(
    '/v1/diamonds/diamond-card/claim'
  )
}

export type EnergyLimitExchangeConfig = {
  diamondExchange: {
    // 每次兑换需要多少钻石
    diamond: 0
    // 每次兑换增加多少面包上限
    energyLimit: 0
  }
  // 已经增加的面包上限
  addedEnergyLimit: 0

  // 最大能增加多少面包上限
  maxEnergyLimitCapacity: 0
}

export async function fetchEnergyLimitExchangeConfig() {
  return api.get<never, EnergyLimitExchangeConfig>(
    '/v1/diamonds/energy-limit-exchange'
  )
}
